import { AfterViewInit, Component, Input } from '@angular/core';
import * as moment from 'moment';
import { ScreeningLight } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-applicant-info',
  templateUrl: './applicant-info.component.html',
  styleUrls: ['./applicant-info.component.less']
})
export class ApplicantInfoComponent implements AfterViewInit{
  @Input()screeningToEdit : ScreeningLight;
  canUnmaskPII: boolean = false;

  calculatedAge: number;

 constructor(public auth : AuthService)
 {
    if(this.auth.UserInRole('CRA')) this.canUnmaskPII = true;

  }
  ngAfterViewInit(): void {
    var today = moment();
    var dob = moment(this.screeningToEdit.applicantDOB);
    var diff = today.diff(dob, 'years');
    this.calculatedAge = diff;
  }
  
 onHover(val: boolean): void {
    if(this.auth.UserInRole('CRA')) {
      return; //CRAs permanently unmask PII
    } 
    else if (this.auth.UserInRole('UnmaskPII')) {
      this.canUnmaskPII = val;
    }
  }
}
